/**
 * @generated SignedSource<<7d8b2712dcb86facb8eb343bbe88523c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type usePanelConfigurationQuery$variables = {};
export type usePanelConfigurationQuery$data = {
  readonly panelConfiguration: {
    readonly country: string;
    readonly countryDetails: {
      readonly alpha2: string;
      readonly alpha3: string;
      readonly phoneNumberPrefixes: ReadonlyArray<number>;
    };
    readonly referralsOptions: {
      readonly enabled: boolean;
      readonly panelistAmountCurrency: string;
      readonly referrerAmountCents: number;
    };
    readonly registrationOptions: {
      readonly email: boolean;
      readonly minAge: number;
      readonly phoneNumber: boolean;
    };
  } | null;
};
export type usePanelConfigurationQuery = {
  response: usePanelConfigurationQuery$data;
  variables: usePanelConfigurationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "country",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "RegistrationOptions",
  "kind": "LinkedField",
  "name": "registrationOptions",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phoneNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minAge",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "CountryDetails",
  "kind": "LinkedField",
  "name": "countryDetails",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phoneNumberPrefixes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alpha2",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alpha3",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "ReferralsOptions",
  "kind": "LinkedField",
  "name": "referralsOptions",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "referrerAmountCents",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "panelistAmountCurrency",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "usePanelConfigurationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PanelConfiguration",
        "kind": "LinkedField",
        "name": "panelConfiguration",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "usePanelConfigurationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PanelConfiguration",
        "kind": "LinkedField",
        "name": "panelConfiguration",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8da3f04a32c466e2466536606f4f1a46",
    "id": null,
    "metadata": {},
    "name": "usePanelConfigurationQuery",
    "operationKind": "query",
    "text": "query usePanelConfigurationQuery {\n  panelConfiguration {\n    country\n    registrationOptions {\n      phoneNumber\n      email\n      minAge\n    }\n    countryDetails {\n      phoneNumberPrefixes\n      alpha2\n      alpha3\n    }\n    referralsOptions {\n      enabled\n      referrerAmountCents\n      panelistAmountCurrency\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "6ef356037245a4acc4b03edd2e48807f";

export default node;
